import React from "react";
import { motion } from "framer-motion";
import { Calendar, AlertCircle } from "lucide-react";
import { formatShortDateTime } from "../../utils/datetime";
import "../../css/dashboard/upcomingVisits.css";

export default function UpcomingVisits({ visits = [] }) {
  const now = new Date();

  /* Filter: scheduled + future date */
  const scheduledVisits = Array.isArray(visits)
    ? visits
        .filter((v) => v.status === "scheduled" && new Date(v.scheduled_date) >= now)
        .sort((a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date))
    : [];

  const noVisits = scheduledVisits.length === 0;

  /* Normalize property name */
  const normalizedVisits = scheduledVisits.map((v) => ({
    ...v,
    propertyName:
      typeof v.property_id === "object"
        ? v.property_id?.propertyName
        : null,
  }));

  return (
    <div className={`visits-card${noVisits ? " visits-card--alert" : ""}`}>
      {/* Header */}
      <div className="visits-header">
        <div className="visits-header-left">
          <div className={`visits-header-icon${noVisits ? " visits-header-icon--alert" : ""}`}>
            <Calendar size={16} />
          </div>
          <div>
            <h2>Upcoming Site Visits</h2>
            <p className={`visits-header-sub${noVisits ? " visits-header-sub--alert" : ""}`}>
              {noVisits
                ? "0 scheduled visits"
                : `${scheduledVisits.length} visit${scheduledVisits.length !== 1 ? "s" : ""} scheduled`}
            </p>
          </div>
        </div>
        {noVisits && <AlertCircle size={18} color="#DC2626" />}
      </div>

      {/* Body */}
      <div className="visits-body">
        {noVisits ? (
          <div className="visits-empty visits-empty--alert">
            <div className="visits-empty-icon--alert">
              <Calendar size={24} />
            </div>
            <p className="visits-empty-title">No upcoming site visits</p>
            <p className="visits-empty-sub">Schedule a visit to keep the pipeline moving.</p>
          </div>
        ) : (
          normalizedVisits.map((visit, index) => (
            <motion.div
              key={visit._id}
              className="visit-row"
              initial={{ opacity: 0, x: 16 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.07 }}
            >
              <div className="visit-icon">
                <Calendar size={15} />
              </div>
              <div className="visit-info">
                <p className="visit-date">
                  {visit.scheduled_date
                    ? formatShortDateTime(visit.scheduled_date)
                    : "Date TBD"}
                </p>
                <p className="visit-property">
                  {visit.propertyName
                    ? visit.propertyName
                    : visit.property_id
                    ? `Property #${String(visit.property_id).slice(-6)}`
                    : "Property not specified"}
                </p>
              </div>
            </motion.div>
          ))
        )}
      </div>
    </div>
  );
}
